module.exports = __webpack_public_path__ + "assets/img/vu.06db8578.gif";